/** Dealer adds this offset so a requeued-after-park event sorts to the top. */
export const REQUEUED_AFTER_PARK_PRIORITY = 10_000_000;

export function isRequeuedAfterPark(priority: unknown): boolean {
  return (
    typeof priority === 'number' &&
    Number.isFinite(priority) &&
    priority >= REQUEUED_AFTER_PARK_PRIORITY
  );
}

/** Visible queue priority. Boosted values show `priority - REQUEUED_AFTER_PARK_PRIORITY`. */
export function displayQueuePriority(priority: unknown): number {
  if (typeof priority !== 'number' || !Number.isFinite(priority)) {
    return 0;
  }
  return isRequeuedAfterPark(priority) ? priority - REQUEUED_AFTER_PARK_PRIORITY : priority;
}
